import { CrawledPostParam, PutCrawledPostParam } from "@/Interfaces/I_postManagement";
import { customAxios } from "..";

export const fetchCrawledPostApi = (data: CrawledPostParam) => 
  customAxios({
    url: 'hktv_koc/cms/crawledPosts',
    method: 'GET',
    params: data,
  })

export const patchCrawledPostApi = (data: PutCrawledPostParam) => 
  customAxios({
    url: `hktv_koc/cms/crawledPosts`,
    method: 'PATCH',
    data,
  })